module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-100"
  }, [_c('div', {
    staticClass: "row h-100"
  }, [_c('div', {
    staticClass: "col-sm h-100"
  }, [_c('img', {
    staticClass: "h-100 w-100 mx-auto",
    staticStyle: {
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.background_image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm align-self-center"
  }, [_c('div', {
    staticClass: "ql-editor",
    staticStyle: {
      "height": "unset"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-560470b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/player/page/leftpicrighttext.vue
// module id = 112
// module chunks = 0